import Contract from "slotworks/utils/contract";
import ExtendedSpine from "slotworks/graphics/spine/spine";
import { sequence } from "slotworks/utils/race-utils";
import Layers from "slotworks/graphics/layers/layers";

export function GlowTransitionCommand(): Contract<void> {
    return sequence([
        () => Layers.Custom.get("Glow").setScene("glow"),
        () => Layers.Custom.get("Glow").defaultScene()
    ]);
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/commands/glow-transition-command.ts